import { getParametroLectura } from '../dataService';
import FacturaDetalleDAL from '../DAL/FacturaDetalleDAL';
import ParametrosGeneralesDAL from '../DAL/ParametrosGaneralesDAL';
import HistoricoFacturaDAL from '../DAL/HistoricoFacturaDAL';
import FacturaDAL from '../DAL/FacturaDAL';
import FechaHora from '@/utils/FechaHora';


import QRCode from 'qrcode';
import { jsPDF } from "jspdf";
import { getDataBase } from '../db';
import PaqueteTodoFacilController from '../controllers/PaqueteTodoFacilController';

export default class ImprimirBLL {

    oClienteGeneracionLectura;
    constructor(toClienteGeneracionLectura) {
        this.oClienteGeneracionLectura = toClienteGeneracionLectura
    }

    async GetFactura(Cliente, CodigoUbicacion, Lectura_Actual, Lectura_Anterior, Consumo, Cobro, GeneracionFactura, DataBaseAlias, EmpresaNombre) {
    
        const loPaquete = new PaqueteTodoFacilController();
        // const parametroLectura = await ParametroLectura.on(DataBaseAlias).get();
        const parametroLectura = await getParametroLectura();
        const tipoAviso = parametroLectura[0].TipoAviso;

        // const pdfCosepW = new CosepW();
        // const pdfCosphul = new Cosphul();
        let pdf;
        console.log('==> tipos aviso : ' , tipoAviso);
        
        switch (Number(tipoAviso)) {
            case 0:
                // pdf = await pdfCosepW.GetFacturaCosepW(Cliente, CodigoUbicacion, Lectura_Actual, Lectura_Anterior, Consumo, Cobro, GeneracionFactura, DataBaseAlias, EmpresaNombre);
                pdf = await this.GetFacturaCosepW(Cliente, CodigoUbicacion, Lectura_Actual, Lectura_Anterior, Consumo, Cobro, GeneracionFactura, DataBaseAlias, EmpresaNombre);
                break;
            case 1:
                // Caso 1 comentado en el código original
                loPaquete.error = 1;
                loPaquete.status = 0;
                loPaquete.message = 'NO DISPONIBLE';
                return loPaquete;
                break;
            case 2:
                // pdf = await pdfCosphul.GetFacturaCosphul(Cliente, CodigoUbicacion, Lectura_Actual, Lectura_Anterior, Consumo, Cobro, GeneracionFactura, DataBaseAlias, EmpresaNombre);
                // loPaquete.error = 1;
                // loPaquete.status = 0;
                // loPaquete.message = 'Cosphul NO DISPONIBLE';
                // return loPaquete;
                // break;
                pdf = await this.GetFacturaCosepW(Cliente, CodigoUbicacion, Lectura_Actual, Lectura_Anterior, Consumo, Cobro, GeneracionFactura, DataBaseAlias, EmpresaNombre);
                break;
            case 3:
                // pdf = await pdfCosepW.GetFacturaCosepW(Cliente, CodigoUbicacion, Lectura_Actual, Lectura_Anterior, Consumo, Cobro, GeneracionFactura, DataBaseAlias, EmpresaNombre);
                pdf = await this.GetFacturaBuenaVista(Cliente, CodigoUbicacion, Lectura_Actual, Lectura_Anterior, Consumo, Cobro, GeneracionFactura, DataBaseAlias, EmpresaNombre);
                break;
            default:
                // pdf = await pdfCosepW.GetFacturaCosepW(Cliente, CodigoUbicacion, Lectura_Actual, Lectura_Anterior, Consumo, Cobro, GeneracionFactura, DataBaseAlias, EmpresaNombre);
                pdf = await this.GetFacturaCosepW(Cliente, CodigoUbicacion, Lectura_Actual, Lectura_Anterior, Consumo, Cobro, GeneracionFactura, DataBaseAlias, EmpresaNombre);
                break;
        }

        return pdf;
    }

    async getParametroLectura() {
        try {
            const db = await getDataBase();
            const tx = db.transaction('PARAMETROLECTURA', 'readonly');
            const store = tx.objectStore('PARAMETROLECTURA');
            const loData = await store.getAll(1);
            await tx.done;
            return loData;
        } catch (error) {
            console.error('Error al buscar cliente por Cliente:', error);
            return [];
        }
    }

    async GetFacturaCosepW(Cliente, CodigoUbicacion, Lectura_Actual, Lectura_Anterior, Consumo, Cobro, GeneracionFactura, DataBaseAlias, EmpresaNombre) {
    
   
        const ParaQR = await this.getParaQRTable();
        const URL = ParaQR[0].Url.trim();
        const ComerceID = ParaQR[0].ComerceID.trim();
        const QR = `${URL}${ComerceID}/${Cliente}`;
        const loFechaHora = new FechaHora();
        //sacar de localstorage
        const Usuario = [{
            Nombre: localStorage.getItem('NombreUsuario'),
            Apellidos: localStorage.getItem('ApellidoUsuario'),
        }];




        let Lecturador = '';
        if (Usuario) {
            Lecturador = `Emitido por: ${Usuario[0].Nombre} ${Usuario[0].Apellidos} Fecha: ${loFechaHora.getFecha()} ${loFechaHora.getHora()}`;
        }

        const laCliente = [];
        laCliente.push({
            Direccion: this.oClienteGeneracionLectura.Direccion,
            Manzana: this.oClienteGeneracionLectura.Manzana,
            Uv: this.oClienteGeneracionLectura.Uv,
            Lote: this.oClienteGeneracionLectura.Lote,
            Nombre: this.oClienteGeneracionLectura.Nombre,
            NombreCategoria: this.oClienteGeneracionLectura.NombreCategoria,
        });

        // Fetch invoice data
     
         const FacturaDALInstance = new FacturaDAL();
        
         const laFacturaCliente = await FacturaDALInstance.GetDatosFacturaSocio(GeneracionFactura, Cliente, DataBaseAlias);
        console.warn('laFacturaCliente: ', laFacturaCliente);
        
        // const laFacturaCliente = await this.GetDatosFacturaSocio(GeneracionFactura, Cliente);
        const FechaEmision = laFacturaCliente[0].FechaEmision;
        const Corte = laFacturaCliente[0].Corte;
   
         const FechaCorte = await FacturaDALInstance.GetFechaCorte(FechaEmision, Corte, DataBaseAlias);
  
        // const FechaCorte = await this.GetFechaCorte(FechaEmision, Corte);

        // Fetch historical data
     
        const HistoricoFacturaDALInstance = new HistoricoFacturaDAL();
        const laHistorial = await HistoricoFacturaDALInstance.TraerHistorial(Cliente, DataBaseAlias);
    
        const FechaAnteriorData = await HistoricoFacturaDALInstance.GetFechaLecturaAnterior(Cliente, DataBaseAlias);

        let ConsumoAnterior;
        if (laHistorial.length > 0 && laHistorial[0].M3 != undefined) {
            ConsumoAnterior = laHistorial[0].M3;
        } else {
            ConsumoAnterior = 0;
        }
      
        //TODO: AQUI , GENERAR PDF CON JS. 
        const facturaDetalleDAL = new FacturaDetalleDAL();
        // const lnFactura = this.oClienteGeneracionLectura.Factura;
        
        const laFacturaDetalle = await facturaDetalleDAL.GetDetalleFactura(Cliente, DataBaseAlias);
        const parametrosGeneralesDAL = new ParametrosGeneralesDAL();
        const laParametrosGenerales = await parametrosGeneralesDAL.GetAlldt(DataBaseAlias);
        const contar = laFacturaDetalle.length;

        let Historico = [];
        let HistoricoServicio  = [];
        let ImporteFactura = 0;
        let TotalDeuda = 0;
        let NumeroMeses = 0;
        let DeudaAtrasada = 0;
        let NFactura = 0;
        let Indice = 0;
  
        for (let i = 0; i <= 11; i++) {
           
            let loDatos = {};
            if (NFactura == 0) {
                loDatos = {
                    Cobro: laFacturaCliente[0].Cobro,
                    Consumo: Math.round(laFacturaCliente[0].Consumo, 0),
                    MontoTotal: Number(parseFloat(laFacturaCliente[0].MontoTotal).toFixed(2)),
                    Estado: laFacturaCliente[0].Estado == 1 ? "Impaga" : "Pagado"
                };

                NFactura++;
            } else {
                // if (laHistorial[Indice] && laHistorial[Indice].M3) {
                if (laHistorial[Indice]?.M3) {
                    //   Historial = `<tr>
                    //     <td align="left" style="padding: 0;">${historial[indice].Mes}
                    //     <span style="float:right;">${Math.round(historial[indice].M3, 0)}</span></td>`;
                    //   Historial += `<td align="right" style="padding-top: 0; padding-bottom: 0;  padding-left: 0; padding-right: 10px;">${historial[indice].MontoFactura}</td>`;
                    //   Historial += `<td align="left" style="padding-top: 0; padding-bottom: 0;  padding-left: 35px; padding-right: 0;">${historial[indice].Estado}</td>`;
                    loDatos = {
                        Cobro: laHistorial[Indice].Mes,
                        Consumo: Math.round(laHistorial[Indice].M3, 0),
                        MontoTotal: laHistorial[Indice].MontoFactura,
                        Estado: laHistorial[Indice].Estado
                    }

                    if (laHistorial[Indice].Estado == 'Impaga') {
                        TotalDeuda +=  Number(laHistorial[Indice].MontoFactura);
                        NumeroMeses++;
                    }
                    Indice++;


                } else {
                    //   Historial = `<tr>
                    //     <td align="center" style="padding: 0; color:#FFFFFF"> PRUEBA </td>`;
                    //   Historial += `<td align="right" style="padding: 0; color:#FFFFFF"> PRUEBA </td>`;
                    //   Historial += `<td align="left" style="padding: 0; color:#FFFFFF"> PRUEBA </td>`;

                    loDatos = {
                        Cobro: '',
                        Consumo: '',
                        MontoTotal: '',
                        Estado: ''
                    };

                    Indice++;
                }
            }

            //   historico += Historial;
            Historico.push(loDatos);
        }

        for (let i = 0; i < contar; i++) {
            const loDatos = {
                Servicio: laFacturaDetalle[i].Servicio,
                NombreServicio: laFacturaDetalle[i].NombreServicio,
                MontoPago: laFacturaDetalle[i].MontoPago
            };

            ImporteFactura += Number(laFacturaDetalle[i].MontoPago);
            HistoricoServicio.push(loDatos);
        }


        DeudaAtrasada = Number(TotalDeuda);
        DeudaAtrasada = parseFloat(DeudaAtrasada.toFixed(2));
        TotalDeuda = Number(TotalDeuda) + Number(laFacturaCliente[0].MontoTotal);
        TotalDeuda = parseFloat(TotalDeuda.toFixed(2));
        ImporteFactura = parseFloat(ImporteFactura.toFixed(2));

  
        // Mes actual
        const mes = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"][new Date().getMonth()];

        // Convertir `Cobro` a timestamp y formatear la fecha
        const timestamp = new Date(Cobro);
        const newDate = `${mes}-${timestamp.getFullYear()}`;

        let FechaAnterior = "00/00/00";

        if (FechaAnteriorData[0]?.FechaLectura) {
            const fechaLecturaStr = FechaAnteriorData[0].FechaLectura;
            const timestamp2 = new Date(`${fechaLecturaStr}T00:00:00`);
            FechaAnterior = timestamp2.toLocaleDateString('es-ES',{ day: '2-digit', month: '2-digit', year: 'numeric' }); // Formato: dd/mm/yyyy
        }

        // Formatear `FechaVence`
        const fechaVenceStr = laFacturaCliente[0].FechaVence;
        const timestamp3 = new Date(`${fechaVenceStr}T00:00:00`);
        const FechaVence = timestamp3.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }); // Formato: dd/mm/yyyy


        // Obtener mensajes del cliente
        // let loMensaje = new MensajeClienteDAL();
       let loMensaje = await this.GetMensajes(Cobro);
      
                // Componer el mensaje si existe
        let MensajePrueba = '';
        if (loMensaje.length != 0) {
            MensajePrueba = `${loMensaje[0].Linea1} ${loMensaje[0].Linea2} ${loMensaje[0].Linea3} ${loMensaje[0].Linea4} ${loMensaje[0].Linea5}`;
        } else {
            MensajePrueba = '';
        }

  
        //preparar datos para enviar
        const loDatosPdf = {
            Cliente: Cliente,
            laCliente: laCliente,
            Lecturador: Lecturador,
            NewDate: newDate,
            FechaVence: FechaVence,
            CodigoUbicacion: CodigoUbicacion,
            LecturaActual: Lectura_Actual,
            LecturaAnterior: Lectura_Anterior,
            Consumo: Consumo,
            laFacturaCliente: laFacturaCliente,
            NumeroMeses: NumeroMeses,
            DeudaAtrasada: DeudaAtrasada,
            FechaCorte: FechaCorte,
            FechaAnterior: FechaAnterior,
            ConsumoAnterior: ConsumoAnterior,
            mensajePrueba: MensajePrueba,
            QRPago: QR,
            Historico: Historico,
            HistoricoServicio: HistoricoServicio,
            TotalDeuda: TotalDeuda,
            ImporteFactura: ImporteFactura,
            ParaQR: ParaQR,
        }

        return  this.generarPDF(loDatosPdf);
      
    }

    async GetFacturaBuenaVista(Cliente, CodigoUbicacion, Lectura_Actual, Lectura_Anterior, Consumo, Cobro, GeneracionFactura, DataBaseAlias, EmpresaNombre) {
   
   
        const ParaQR = await this.getParaQRTable();
        const URL = ParaQR[0].Url.trim();
        const ComerceID = ParaQR[0].ComerceID.trim();
        const QR = `${URL}${ComerceID}/${Cliente}`;
        const loFechaHora = new FechaHora();
        //sacar de localstorage
        const Usuario = [{
            Nombre: localStorage.getItem('NombreUsuario'),
            Apellidos: localStorage.getItem('ApellidoUsuario'),
        }];


        let Lecturador = '';
        if (Usuario) {
            Lecturador = `Emitido por: ${Usuario[0].Nombre} ${Usuario[0].Apellidos} Fecha: ${loFechaHora.getFecha()} ${loFechaHora.getHora()}`;
        }

        const laCliente = [];
        laCliente.push({
            Direccion: this.oClienteGeneracionLectura.Direccion,
            Manzana: this.oClienteGeneracionLectura.Manzana,
            Uv: this.oClienteGeneracionLectura.Uv,
            Lote: this.oClienteGeneracionLectura.Lote,
            Nombre: this.oClienteGeneracionLectura.Nombre,
            NombreCategoria: this.oClienteGeneracionLectura.NombreCategoria,
        });

        // Fetch invoice data
     
         const FacturaDALInstance = new FacturaDAL();

         const laFacturaCliente = await FacturaDALInstance.GetDatosFacturaSocio(GeneracionFactura, Cliente, DataBaseAlias);
        console.warn('laFacturaCliente: ', laFacturaCliente);
        
        // const laFacturaCliente = await this.GetDatosFacturaSocio(GeneracionFactura, Cliente);
        const FechaEmision = laFacturaCliente[0].FechaEmision;
        const Corte = laFacturaCliente[0].Corte;
   
         const FechaCorte = await FacturaDALInstance.GetFechaCorte(FechaEmision, Corte, DataBaseAlias);
  
        // const FechaCorte = await this.GetFechaCorte(FechaEmision, Corte);

        // Fetch historical data
     
        const HistoricoFacturaDALInstance = new HistoricoFacturaDAL();
        const laHistorial = await HistoricoFacturaDALInstance.TraerHistorial(Cliente, DataBaseAlias);
    
        const FechaAnteriorData = await HistoricoFacturaDALInstance.GetFechaLecturaAnterior(Cliente, DataBaseAlias);

        let ConsumoAnterior;
        if (laHistorial.length > 0 && laHistorial[0].M3 != undefined) {
            ConsumoAnterior = laHistorial[0].M3;
        } else {
            ConsumoAnterior = 0;
        }
      
        //TODO: AQUI , GENERAR PDF CON JS. 
        const facturaDetalleDAL = new FacturaDetalleDAL();
        // const lnFactura = this.oClienteGeneracionLectura.Factura;
        
        const laFacturaDetalle = await facturaDetalleDAL.GetDetalleFactura(Cliente, DataBaseAlias);
        const parametrosGeneralesDAL = new ParametrosGeneralesDAL();
        const laParametrosGenerales = await parametrosGeneralesDAL.GetAlldt(DataBaseAlias);
        const contar = laFacturaDetalle.length;


        let Historico = [];
        let HistoricoServicio  = [];
        let ImporteFactura = 0;
        let TotalDeuda = 0;
        let NumeroMeses = 0;
        let DeudaAtrasada = 0;
        let NFactura = 0;
        let Indice = 0;
     
        for (let i = 0; i <= 11; i++) {
           
            let loDatos = {};
            if (NFactura == 0) {
                loDatos = {
                    Cobro: laFacturaCliente[0].Cobro,
                    Consumo: Math.round(laFacturaCliente[0].Consumo, 0),
                    MontoTotal: Number(parseFloat(laFacturaCliente[0].MontoTotal).toFixed(2)),
                    Estado: laFacturaCliente[0].Estado == 1 ? "Impaga" : "Pagado"
                };

                NFactura++;
            } else {
                // if (laHistorial[Indice] && laHistorial[Indice].M3) {
                if (laHistorial[Indice]?.M3) {
                    //   Historial = `<tr>
                    //     <td align="left" style="padding: 0;">${historial[indice].Mes}
                    //     <span style="float:right;">${Math.round(historial[indice].M3, 0)}</span></td>`;
                    //   Historial += `<td align="right" style="padding-top: 0; padding-bottom: 0;  padding-left: 0; padding-right: 10px;">${historial[indice].MontoFactura}</td>`;
                    //   Historial += `<td align="left" style="padding-top: 0; padding-bottom: 0;  padding-left: 35px; padding-right: 0;">${historial[indice].Estado}</td>`;
                    loDatos = {
                        Cobro: laHistorial[Indice].Mes,
                        Consumo: Math.round(laHistorial[Indice].M3, 0),
                        MontoTotal: laHistorial[Indice].MontoFactura,
                        Estado: laHistorial[Indice].Estado
                    }

                    if (laHistorial[Indice].Estado == 'Impaga') {
                        TotalDeuda +=  Number(laHistorial[Indice].MontoFactura);
                        NumeroMeses++;
                    }
                    Indice++;


                } else {
                    //   Historial = `<tr>
                    //     <td align="center" style="padding: 0; color:#FFFFFF"> PRUEBA </td>`;
                    //   Historial += `<td align="right" style="padding: 0; color:#FFFFFF"> PRUEBA </td>`;
                    //   Historial += `<td align="left" style="padding: 0; color:#FFFFFF"> PRUEBA </td>`;
                
                    loDatos = {
                        Cobro: '',
                        Consumo: '',
                        MontoTotal: '',
                        Estado: ''
                    };

                    Indice++;
                }
            }

            //   historico += Historial;
            Historico.push(loDatos);
        }

        for (let i = 0; i < contar; i++) {
            const loDatos = {
                Servicio: laFacturaDetalle[i].Servicio,
                NombreServicio: laFacturaDetalle[i].NombreServicio,
                MontoPago: laFacturaDetalle[i].MontoPago
            };

            ImporteFactura += Number(laFacturaDetalle[i].MontoPago);
            HistoricoServicio.push(loDatos);
        }


        DeudaAtrasada = Number(TotalDeuda);
        DeudaAtrasada = parseFloat(DeudaAtrasada.toFixed(2));
        TotalDeuda = Number(TotalDeuda) + Number(laFacturaCliente[0].MontoTotal);
        TotalDeuda = parseFloat(TotalDeuda.toFixed(2));
        ImporteFactura = parseFloat(ImporteFactura.toFixed(2));

  
        // Mes actual
        const mes = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"][new Date().getMonth()];

        // Convertir `Cobro` a timestamp y formatear la fecha
        const timestamp = new Date(Cobro);
        const newDate = `${mes}-${timestamp.getFullYear()}`;

        let FechaAnterior = "00/00/00";

        if (FechaAnteriorData[0]?.FechaLectura) {
            const fechaLecturaStr = FechaAnteriorData[0].FechaLectura;
            const timestamp2 = new Date(`${fechaLecturaStr}T00:00:00`);
            FechaAnterior = timestamp2.toLocaleDateString('es-ES',{ day: '2-digit', month: '2-digit', year: 'numeric' }); // Formato: dd/mm/yyyy
        }

        // Formatear `FechaVence`
        const fechaVenceStr = laFacturaCliente[0].FechaVence;
        const timestamp3 = new Date(`${fechaVenceStr}T00:00:00`);
        const FechaVence = timestamp3.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }); // Formato: dd/mm/yyyy


        // Obtener mensajes del cliente
        // let loMensaje = new MensajeClienteDAL();
       let loMensaje = await this.GetMensajes(Cobro);
      
                // Componer el mensaje si existe
        let MensajePrueba = '';
        if (loMensaje.length != 0) {
            MensajePrueba = `${loMensaje[0].Linea1} ${loMensaje[0].Linea2} ${loMensaje[0].Linea3} ${loMensaje[0].Linea4} ${loMensaje[0].Linea5}`;
        } else {
            MensajePrueba = '';
        }

  
        //preparar datos para enviar
        const loDatosPdf = {
            Cliente: Cliente,
            laCliente: laCliente,
            Lecturador: Lecturador,
            NewDate: newDate,
            FechaVence: FechaVence,
            CodigoUbicacion: CodigoUbicacion,
            LecturaActual: Lectura_Actual,
            LecturaAnterior: Lectura_Anterior,
            Consumo: Consumo,
            laFacturaCliente: laFacturaCliente,
            NumeroMeses: NumeroMeses,
            DeudaAtrasada: DeudaAtrasada,
            FechaCorte: FechaCorte,
            FechaAnterior: FechaAnterior,
            ConsumoAnterior: ConsumoAnterior,
            mensajePrueba: MensajePrueba,
            QRPago: QR,
            Historico: Historico,
            HistoricoServicio: HistoricoServicio,
            TotalDeuda: TotalDeuda,
            ImporteFactura: ImporteFactura,
            ParaQR: ParaQR,
        }

        return  this.generarPDFBuenasVista(loDatosPdf);
      
    }



    async getParaQRTable() {
        try {
            const db = await getDataBase();
            const tx = db.transaction('PARAQR', 'readonly');
            const store = tx.objectStore('PARAQR');
            const loData = await store.getAll();
            await tx.done;
            return loData;
        } catch (error) {
            console.error('Error al obtener los parametros para la tabla QR', error);
            return [];
        }
    }

  


    




    async generarPDF(toDatosPdf) {
       const loPaquete = new PaqueteTodoFacilController();
        try {
            //   console.log(toDatosPdf);
                const laCliente = toDatosPdf.laCliente[0];
                const laFacturaCliente = toDatosPdf.laFacturaCliente[0];
                
                const laHistorico = toDatosPdf.Historico;
                const laHistoricoServicio = toDatosPdf.HistoricoServicio;
                const today = new Date();
                const formattedDate = `${today.getDate().toString().padStart(2, '0')}/${(today.getMonth() + 1).toString().padStart(2, '0')}/${today.getFullYear()}`;

       
        
                //XDQRCode
                const doc = new jsPDF({
                    orientation: 'landscape',
                    unit: 'pt',
                    format: [596.20, 289.13]
                });

                       //calcular el maxiom de y y x 
                       const y = doc.internal.pageSize.height;
                       const x = doc.internal.pageSize.width;
                   
        
        
                // Configuración de la fuente
                doc.setFontSize(16);
                doc.setFont("Helvetica", "bold");
                doc.text(laCliente.Nombre,x - 0, y- 70, { angle : 180});
                doc.text(toDatosPdf.Cliente.toString(),x - 500,y-  44, { angle : 180});
                doc.text(toDatosPdf.CodigoUbicacion,x - 110,y-  108, { angle : 180});
                doc.text(toDatosPdf.DeudaAtrasada.toString(),x - 300,y-  138, { angle : 180});
                doc.text(toDatosPdf.NumeroMeses.toString(),x - 390, y- 138, { angle : 180});
        
                // // Detalles de dirección y código cliente
                doc.setFontSize(8);
                doc.text(laCliente.NombreCategoria, x- 380,  y -70 , { angle : 180});
                doc.text( formattedDate , x- 500,  y -70 , { angle : 180});
                doc.text(toDatosPdf.NewDate,x-  380,  y -94 , { angle : 180});
                doc.text(toDatosPdf.FechaVence, x- 500,  y -94 , { angle : 180});
               // UV- '. $laCliente[0]->Uv .' MZ. '. $laCliente[0]->Manzana .' L. '. $laCliente[0]->Lote .' '. $laCliente[0]->Direccion .'
                doc.text( 'UV- '+ laCliente.Uv + ' MZ. '+ laCliente.Manzana + ' L. ' + laCliente.Lote + ' ' + laCliente.Direccion,x-  0, y - 94 , { angle : 180});
        





                // // Fechas y Lectura
                // doc.setFontSize(12);
                doc.text(formattedDate , x- 22,  y- 134, {angle : 180});
                doc.text(toDatosPdf.LecturaActual.toString(), x- 90,  y- 134, {angle : 180});
                doc.text(toDatosPdf.Consumo.toString(), x- 148,  y- 134, {angle : 180});
               

              
                doc.text(toDatosPdf.FechaAnterior, x- 22, y-  141, {angle : 180});
                doc.text(toDatosPdf.LecturaAnterior, x- 90,  y- 141, {angle : 180});
                doc.text( Math.round(Number(toDatosPdf.ConsumoAnterior)).toString(), x- 148, y-  141, {angle : 180});
                doc.text(laFacturaCliente.MedidorAnormalidad.toString(), x- 200, y-  138, {angle : 180});

                

                //FechaCorte
                const lbMostrarCorte = !toDatosPdf.FechaCorte ? "" : "SÍ";
                doc.text(lbMostrarCorte,x-  514,  y- 130, {angle : 180});
                doc.text(toDatosPdf.FechaCorte, x- 500,  y- 138, {angle : 180});
        



                // // Texto rotado en el lado derecho
                doc.setFontSize(8);
                doc.text(toDatosPdf.Lecturador, x- 580, y- 275, { angle: 270 });
        
                doc.setFontSize(8);
                let lnAltura = 178;
                // let array = ['7', '18', '0', '21', '12', '15', '9', '6', '3', '101', '20', '11'];
                // let arrayMoneda = ["115.67", "246.84", "72.45", "198.32", "159.29", "45.78", "280.43", "103.50", "67.89", "234.12", "150.99", "299.03"];
        
                for (let i = 0; i < laHistorico.length; i++) {
                    doc.text(laHistorico[i].Cobro, x- 0, y-lnAltura, { angle: 180 });
        
                    let quitar = 4;
                    quitar = quitar * (laHistorico[i].Consumo.toString().length - 1);
        
                    let qui2 = 4;
                    qui2 = qui2 * (laHistorico[i].MontoTotal.toString().length - 1);
        
                    doc.text(laHistorico[i].Consumo.toString(),x- (70 - quitar),y- lnAltura, { angle: 180 });
                    doc.text(laHistorico[i].MontoTotal.toString(),x- (120 - qui2),y- lnAltura, { angle: 180 });
                    doc.text(laHistorico[i].Estado,x- 140,y- lnAltura, { angle: 180 });
                    lnAltura = lnAltura + 7.3;
        
                }
        
        
                lnAltura = 178;
                // Más datos simulados
            
                for (let i = 0; i < laHistoricoServicio.length; i++) {
                  
                    if (laHistoricoServicio[i].MontoPago != 0) {
                        let q1 = 4;
                        q1 = q1 * (laHistoricoServicio[i].Servicio.toString().length - 1);
                        doc.text(laHistoricoServicio[i].Servicio.toString(),x- (213  - q1) , y- lnAltura , { angle: 180 });



                        // doc.text(laHistoricoServicio[i].NombreServicio,x- 235, y- lnAltura , { angle: 180 });
                        //,maximo de 20 caracteres
                        doc.text(laHistoricoServicio[i].NombreServicio.substring(0, 25),x- 235, y- lnAltura , { angle: 180 });

                        let q2 = 4;
                        q2 = q2 * (laHistoricoServicio[i].MontoPago.toString().length - 1);

                        doc.text(laHistoricoServicio[i].MontoPago.toString(),x- (365 - q2), y- lnAltura , { angle: 180 });
                        lnAltura = lnAltura + 7.3;
                    }
                }
        
                doc.setFontSize(6);
                // Ancho máximo del texto antes de que se divida en nuevas líneas
                const maxWidth = 120; // Ajusta el valor según lo necesites

                // Dividir el texto en líneas que se ajusten al ancho especificado
                const textoDividido = doc.splitTextToSize(toDatosPdf.mensajePrueba, maxWidth);
                doc.text( textoDividido , x-380,y- 174, { angle: 180 });
        
        
                //QRCode
                // Generar el código QR como un canvas
                const qrCanvas = document.createElement('canvas');
                await QRCode.toCanvas(qrCanvas, toDatosPdf.QRPago, { width: 120 });
                const qrImageDataUrl = qrCanvas.toDataURL('image/png');
                
                doc.addImage(qrImageDataUrl, 'PNG', 27,30, 70, 70, { angle: 180 });
                  // (x: 40, y: 100, width: 150, height: 150)
        
        
                // // Texto inferior
                doc.setFontSize(14);
                doc.text(toDatosPdf.TotalDeuda.toString(),x- 130, y- 272, { angle: 180 });
        
                doc.setFontSize(14);
                doc.text(toDatosPdf.ImporteFactura.toString(),x- 310, y- 272, { angle: 180 });
        
                // // Texto final del pie de página
                doc.setFontSize(8);
                doc.text("Escanee el QR para direccionar al pago de sus facturas",x- 380, y- 282, { angle: 180 });
          
                // Guardar el PDF
                // doc.save("factura_estilo_similar.pdf");/
                const pdfUrl = doc.output('bloburl');
                window.open(pdfUrl, '_blank');
                
            
        } catch (error) {
            console.log('Error al generar el PDF:', error);
            loPaquete.error = 1;
            loPaquete.status = 0;
            loPaquete.message = 'Ups! Algo salió mal al generar el PDF';
            loPaquete.messageSistema = error.message;
            return loPaquete;
        }
    }


    async generarPDFBuenasVista(toDatosPdf) {
        const loPaquete = new PaqueteTodoFacilController();
         try {
             //   console.log(toDatosPdf);
                 const laCliente = toDatosPdf.laCliente[0];
                 const laFacturaCliente = toDatosPdf.laFacturaCliente[0];
                 
                 const laHistorico = toDatosPdf.Historico;
                 const laHistoricoServicio = toDatosPdf.HistoricoServicio;
                 const today = new Date();
                 const formattedDate = `${today.getDate().toString().padStart(2, '0')}/${(today.getMonth() + 1).toString().padStart(2, '0')}/${today.getFullYear()}`;
 
        
         
                 //XDQRCode
                 const doc = new jsPDF({
                     orientation: 'landscape',
                     unit: 'pt',
                     format: [596.20, 289.13]
                 });
 
                        //calcular el maxiom de y y x 
                        const y = doc.internal.pageSize.height;
                        const x = doc.internal.pageSize.width;
                    
         
         
                 // Configuración de la fuente
                 doc.setFontSize(16);
                 doc.setFont("Helvetica", "bold");

                 //arriba nomesb y vodgios 
                 doc.text(laCliente.Nombre,x - 0, y- 70, { angle : 180});
                 doc.text(toDatosPdf.Cliente.toString(),x - 530,y-  42, { angle : 180});
                 doc.text(toDatosPdf.CodigoUbicacion,x - 110,y-  108, { angle : 180});
                 doc.text(toDatosPdf.DeudaAtrasada.toString(),x - 300,y-  138, { angle : 180});
                 doc.text(toDatosPdf.NumeroMeses.toString(),x - 390, y- 138, { angle : 180});
         

                 // // Detalles de dirección y código cliente
                 doc.setFontSize(8);
                 doc.text(laCliente.NombreCategoria, x- 380,  y -67 , { angle : 180});
                 doc.text( formattedDate , x- 500,  y -67 , { angle : 180});
                 
                 doc.text(toDatosPdf.NewDate,x-  380,  y -92 , { angle : 180});
                 doc.text(toDatosPdf.FechaVence, x- 500,  y -92 , { angle : 180});
                // UV- '. $laCliente[0]->Uv .' MZ. '. $laCliente[0]->Manzana .' L. '. $laCliente[0]->Lote .' '. $laCliente[0]->Direccion .'
                 doc.text( 'UV- '+ laCliente.Uv + ' MZ. '+ laCliente.Manzana + ' L. ' + laCliente.Lote + ' ' + laCliente.Direccion,x-  0, y - 92 , { angle : 180});
         
 
 
 
 
 
                 // // Fechas y Lectura
                 // doc.setFontSize(12);
                 doc.text(formattedDate , x- 22,  y- 132, {angle : 180});
                 doc.text(toDatosPdf.LecturaActual.toString(), x- 90,  y- 132, {angle : 180});
                 doc.text(toDatosPdf.Consumo.toString(), x- 148,  y- 132, {angle : 180});
                
 
                 doc.text(toDatosPdf.FechaAnterior, x- 22, y-  141, {angle : 180});
                 doc.text(toDatosPdf.LecturaAnterior, x- 90,  y- 141, {angle : 180});
                 doc.text( Math.round(Number(toDatosPdf.ConsumoAnterior)).toString(), x- 148, y-  141, {angle : 180});
                 doc.text(laFacturaCliente.MedidorAnormalidad.toString(), x- 200, y-  138, {angle : 180});
 
                 
 
                 //FechaCorte
                 const lbMostrarCorte = !toDatosPdf.FechaCorte ? "" : "SÍ";
                 doc.text(lbMostrarCorte,x-  514,  y- 130, {angle : 180});
                 doc.text(toDatosPdf.FechaCorte, x- 500,  y- 142, {angle : 180});
         
 
 
 
                 // // Texto rotado en el lado derecho
                 doc.setFontSize(8);
                 doc.text(toDatosPdf.Lecturador, x- 575, y- 275, { angle: 270 });
         
                 doc.setFontSize(8);
                 let lnAltura = 178;
                 // let array = ['7', '18', '0', '21', '12', '15', '9', '6', '3', '101', '20', '11'];
                 // let arrayMoneda = ["115.67", "246.84", "72.45", "198.32", "159.29", "45.78", "280.43", "103.50", "67.89", "234.12", "150.99", "299.03"];
         
                 for (let i = 0; i < laHistorico.length; i++) {
                     doc.text(laHistorico[i].Cobro, x- 0, y-lnAltura, { angle: 180 });
         
                     let quitar = 4;
                     quitar = quitar * (laHistorico[i].Consumo.toString().length - 1);
         
                     let qui2 = 4;
                     qui2 = qui2 * (laHistorico[i].MontoTotal.toString().length - 1);
         
                     doc.text(laHistorico[i].Consumo.toString(),x- (70 - quitar),y- lnAltura, { angle: 180 });
                     doc.text(laHistorico[i].MontoTotal.toString(),x- (120 - qui2),y- lnAltura, { angle: 180 });
                     doc.text(laHistorico[i].Estado,x- 140,y- lnAltura, { angle: 180 });
                     lnAltura = lnAltura + 7.3;
         
                 }
         
         
                 lnAltura = 178;
                 // Más datos simulados
             
                 for (let i = 0; i < laHistoricoServicio.length; i++) {
                   
                     if (laHistoricoServicio[i].MontoPago != 0) {
                         let q1 = 4;
                         q1 = q1 * (laHistoricoServicio[i].Servicio.toString().length - 1);
                         doc.text(laHistoricoServicio[i].Servicio.toString(),x- (213  - q1) , y- lnAltura , { angle: 180 });
 
 
 
                         // doc.text(laHistoricoServicio[i].NombreServicio,x- 235, y- lnAltura , { angle: 180 });
                         //,maximo de 20 caracteres
                         doc.text(laHistoricoServicio[i].NombreServicio.substring(0, 25),x- 235, y- lnAltura , { angle: 180 });
 
                         let q2 = 4;
                         q2 = q2 * (laHistoricoServicio[i].MontoPago.toString().length - 1);
 
                         doc.text(laHistoricoServicio[i].MontoPago.toString(),x- (365 - q2), y- lnAltura , { angle: 180 });
                         lnAltura = lnAltura + 7.3;
                     }
                 }
         
                 doc.setFontSize(6);
                 // Ancho máximo del texto antes de que se divida en nuevas líneas
                 const maxWidth = 120; // Ajusta el valor según lo necesites
 
                 // Dividir el texto en líneas que se ajusten al ancho especificado
                 const textoDividido = doc.splitTextToSize(toDatosPdf.mensajePrueba, maxWidth);
                 doc.text( textoDividido , x-380,y- 174, { angle: 180 });
         
         
                 //QRCode
                 // Generar el código QR como un canvas
                 const qrCanvas = document.createElement('canvas');
                 await QRCode.toCanvas(qrCanvas, toDatosPdf.QRPago, { width: 120 });
                 const qrImageDataUrl = qrCanvas.toDataURL('image/png');
                 
                 doc.addImage(qrImageDataUrl, 'PNG', 27,30, 70, 70, { angle: 180 });
                   // (x: 40, y: 100, width: 150, height: 150)
         
         
                 // // Texto inferior
                 doc.setFontSize(14);
                 doc.text(toDatosPdf.TotalDeuda.toString(),x- 130, y- 272, { angle: 180 });
         
                 doc.setFontSize(14);
                 doc.text(toDatosPdf.ImporteFactura.toString(),x- 310, y- 272, { angle: 180 });
         
                 // // Texto final del pie de página
                 doc.setFontSize(8);
                 doc.text("Escanee el QR para direccionar al pago de sus facturas",x- 360, y- 282, { angle: 180 });
           
                 // Guardar el PDF
                 // doc.save("factura_estilo_similar.pdf");/
                 const pdfUrl = doc.output('bloburl');
                 window.open(pdfUrl, '_blank');
                 
             
         } catch (error) {
             console.log('Error al generar el PDF:', error);
             loPaquete.error = 1;
             loPaquete.status = 0;
             loPaquete.message = 'Ups! Algo salió mal al generar el PDF';
             loPaquete.messageSistema = error.message;
             return loPaquete;
         }
     }
 

    async GetMensajes( tcCobro) {
 
        try {
            const db = await getDataBase();
            const tx = db.transaction('MENSAJE', 'readonly');
            const store = tx.objectStore('MENSAJE');
            const index = store.index('Cobro');
            const laData = await index.getAll(tcCobro);
            await tx.done;
            return laData;
        } catch (error) {
            console.error('Error GetMensajes en imprimirBlLL', error);
                 return [];
        }
    }

}